<template>
  <div class="gallery">
    <div>
      <media-gallery
        :display="galleryDisplay"
        :index="sliderIndex"
        @close="galleryDisplay = false"
        :media="activeGalleryMedia"
      >
      </media-gallery>
    </div>
    <div class="thumbnails-wrapper">
      <div         
        :class="boxClass"
        v-for="(medium, mediumIndex) in activeMedia"
        @click="openGallery(mediumIndex)"
        :key="mediumIndex"
      >
        <div class="thumbnails"
            :style="{ backgroundImage: `url(${toSmall(medium)})`, borderColor: borderColor}">
          <img v-if="medium.type === 'Video'" src="https://www.midlandici.com.hk/ics/property/img/details/video-01.svg" class="play-icon" />
          <img v-if="medium.type === 'Vr'" src="/ics/property/img/details/vr-01.svg" class="play-icon" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MediaGallery from '@/components/Building/MediaGallery';

  export default {
    props: ['bgColor', 'big', 'media', 'skip'],
    components: {
      MediaGallery,
    },
    data() {
      return {
        galleryDisplay: false,
        sliderIndex: 0,
      };
    },
    computed: {
      activeMedia() {
        let m = structuredClone(this.media); // clone
        if (this.skip && this.skip > 0) {
          m.splice(0, this.skip);
        }
        return m;
      },
      activeGalleryMedia() {
        let m = structuredClone(this.media);
        if (this.skip && this.skip > 0) {
          m.splice(0, this.skip);
        }
        m = m.filter(med => med.type !== 'Vr');
        return m;
      },
      boxClass() {
        return this.big ? 'thumbnails-box-large' : 'thumbnails-box';
      },
      borderColor() {
        return this.bgColor ? this.bgColor : '#fff';
      },
      thumbnails() {
        const thumbnailList = [];
        for (let i = 0; i < this.videos.length; i += 1) {
          thumbnailList.push(`https://img.youtube.com/vi/${this.videos[i]}/hqdefault.jpg`);
        }
        for (let i = 0; i < this.images.length; i += 1) {
          thumbnailList.push(`${this.images[i]}`);
        }
        return thumbnailList;
      },
    },
    methods: {
      toSmall(medium) {
        if(medium.type === 'Photo') {
          return `${medium.src}/s.jpeg`;
        } else if (medium.type === 'Video' ) {
          return `https://img.youtube.com/vi/${medium.youtubeMrId}/hqdefault.jpg`
        } else if (medium.type === 'Vr') {
           return medium.thumbnail
        }
      },
      openGallery(index) {
        if (this.activeMedia[index].type === 'Vr') {
          const baseUrl = `${window.location.origin}${window.SITE_URL}`;
          const mediaUrl = `media/${this.activeMedia[index].ics}/${this.activeMedia[index].buildingId}/${this.activeMedia[index].id}`;
          window.open(`${baseUrl}${mediaUrl}`, '_blank').focus();
        } else {
          this.activeGalleryMedia.forEach((m, i) => {
            if (m.id === this.activeMedia[index].id) {
              this.galleryDisplay = true;
              this.sliderIndex = i;
            }
          });
        }
      },
      showPlay(i) {
        return i.includes("youtube");
      },
    },
  };
</script>
<style scoped>
  .thumbnails-wrapper {
    display: flex;
    flex-wrap: wrap;
    width:100%;
    padding-bottom: 4px;
  }

  .thumbnails-box {
    width: 12.5%;
    cursor: pointer;
  }

  .thumbnails-box-large {
    width: 33.1%;
    cursor: pointer;
  }

  .thumbnails {
    width: 100%;
    padding-top: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-width: 4px 0px 0px 4px;
    border-style: solid;
    border-color: #fff;
    position: relative;
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);  
  }

  @media (max-width: 500px) { 
    .thumbnails-box {
      width: 25%;
    }
  }@media (max-width: 768px) { 
    .thumbnails-box {
      width: 20%;
    }
  }
</style>